// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__CiSeF","container":"styles_container__1guzh","title":"styles_title__3GHLi","wrapper":"styles_wrapper__3_5tw","answer":"styles_answer__2qBrY"};